<template>
	<div class="relative border rounded-md mb-1">
		<div :style="{ width: Math.round(upload.progress * 100) + '%' }" class="absolute h-1 bg-accent"></div>

		<div class="px-2 py-1 text-sm" v-if="!upload.errors">
			{{upload.file.name}} - <span class="italic">{{ $t('Uploading') }} {{ Math.round(upload.progress * 100) }}%</span>
		</div>

		<template v-else>
			<div class="px-2 py-1 text-sm">
				{{upload.file.name}}
			</div>

			<div class="px-2 text-red-500 flex justify-between items-center text-sm">
				{{ $t('Error') }}: {{ processedErrorMessage }}
				<button type="button" @click="$emit('cancel')">
					<XMarkIcon class="w-5 h-5" />
				</button>
			</div>
		</template>


	</div>
</template>

<script lang="ts">

import { UploadingFile } from "@/models/UploadingFile.model";
import { XMarkIcon } from "@heroicons/vue/24/outline";
import config from '@/config/app.config';

export default {

	emits: [
		'cancel'
	],

	components: {
		XMarkIcon,
	},

	props: {
		upload: {
			type: UploadingFile,
			required: true,
		},
		validationError: {
			type: Error,
		}
	},

	computed: {
		processedErrorMessage(): string {
			if (!this.upload.errors) {
				return '';
			}

			// Map error codes to user-friendly messages
			const errorMessages: Record<string, string> = {
				'MAX_FILE_SIZE_EXCEEDED': this.$t('Maximum file size of {size} exceeded', { size: this.maxFileSize() }) as string,
				// Add more mappings as needed
			};

			return errorMessages[this.upload.errors] || this.upload.errors;
		}
	},

	methods: {
		maxFileSize(): string {
			return config.MAX_FILE_SIZE_MB + 'MB';
		},
	}
}
</script>
